import classNames from "classnames";
import React from "react";
import newsLang from "../../i18n/news";
import ReceiveNewsForm from "./ReceiveNewsForm";

const RegisterDocument = ({ locale, vertical, className }) => {
  return (
    <div
      className={classNames("px-3 py-4", className)}
      style={{ backgroundColor: "#f7e368" }}
    >
      <h4
        className={classNames(
          "text-uppercase mb-0 font-weight-bold",
          vertical && "text-center"
        )}
      >
        {newsLang.formRegister.registerTitle[locale]}
      </h4>
      <div
        className={classNames(
          "row d-flex align-items-top mt-4",
          vertical && "flex-column"
        )}
      >
        <ReceiveNewsForm name email locale={locale} vertical={vertical} />
      </div>
    </div>
  );
};

export default RegisterDocument;
